import React, {useEffect, useState} from 'react';
import { Card, Table, Badge, Dropdown, Pagination } from 'react-bootstrap';
import {authService} from "../../services/authService";
import NotificationService from "../../services/NotificationService";
import {userService} from "../../services/userService";
import {businessYearService} from "../../services/businessYearService";
import eventEmitter from "../../shared/eventEmitter";
import {EventEmitterTypes} from "../../shared/eventEmitterEnum";
import {useNavigate} from "react-router-dom";
import SeasonDatesModal from "./modals/SeasonDatesModal";
import {CustomToggle} from "../../shared/components/CustomYearlySettingsToggleOptions";




export interface Settings {
    created: Date,
    current: boolean,
    maximumWorkAmountPerDay: number,
    webPriceAdjustmentAmount: number,
    scheduleEndDate: Date,
    scheduleStartDate: Date,
    year: number
}

interface YearlySettingsDetailsProps {
    details: Settings;
}



const SeasonDatesCard: React.FC<YearlySettingsDetailsProps> = ({details}) => {
    const [showModal, setShowModal] = useState(false);
    const [startDate, setStartDate] = useState<string>(null);
    const [endDate, setEndDate] = useState<string>(null);
    const [maxDaily, setMaxDaily] = useState<number>(null);
    function addOrdinal(day) {
        if (day >= 11 && day <= 13) {
            return `${day}th`;
        }
        switch (day % 10) {
            case 1:
                return `${day}st`;
            case 2:
                return `${day}nd`;
            case 3:
                return `${day}rd`;
            default:
                return `${day}th`;
        }
    }
    function formatDate(dateStr) {
        const date = new Date(dateStr);
        const month = date.toLocaleString('en-US', { timeZone: 'UTC', month: "long"});
        const day = date.getUTCDate();
        return `${month} ${addOrdinal(day)}`;
    }
    useEffect(() => {
        if(details){
            setStartDate(details.scheduleStartDate.toLocaleString('en-US', {timeZone: 'UTC'}));
            setEndDate(details.scheduleEndDate.toLocaleString('en-US', {timeZone: 'UTC'}));
            setMaxDaily(details.maximumWorkAmountPerDay);
        } else {
            setStartDate(null);
            setEndDate(null);
            setMaxDaily(null);
        }

    }, [details]);
    useEffect(() => {
        const refreshListener = () => {
            businessYearService.getBusinessYear(details.year).then(res => {
                setStartDate(res.scheduleStartDate);
                setEndDate(res.scheduleEndDate);
                setMaxDaily(res.maximumWorkAmountPerDay);
            });
        };

        eventEmitter.on(EventEmitterTypes.REFRESH_LOADED_YEAR_SEASON_DATES, refreshListener);

        return () => {
            eventEmitter.off(EventEmitterTypes.REFRESH_LOADED_YEAR_SEASON_DATES, refreshListener);
        };
    }, []);
    return (<>
    <div className="card yearlySettingsCard">
        <div className="cardHeader">
            <h2 className="">
                <span className="cuteIcon blue">
                    <i className="fa-solid fa-calendar-range"></i>
                </span>
                {details.year} Season
            </h2>
            <div className="cardAction">
                <Dropdown style={{display: 'flex', justifyContent: 'flex-end'}} align="end"
                          className="text-end">
                    <Dropdown.Toggle as={CustomToggle} id="priceSqFtBtn">
                        <i className="fa-solid fa-ellipsis"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item
                            onClick={() => {
                                setShowModal(true);
                            }}
                        >
                            <i className="fa-light fa-pencil fa-fw"></i> Edit
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>
        <div className="cardBody">
            <h3 className="chonky">
                <>{formatDate(startDate)} - {formatDate(endDate)}</>
            </h3>
        </div>
    </div>
    <SeasonDatesModal year={details.year} show={showModal} toggle={() => setShowModal(false)} details={{maximumWorkAmountPerDay: maxDaily, startDate: startDate, endDate: endDate, webPriceAdjustmentAmount: details.webPriceAdjustmentAmount}}/>
    </>);
};

export default SeasonDatesCard;
